// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__CUeZp","selectedButton":"Pagination_selectedButton__Fm32p"};